var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistCritical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.434,
    height: 24.484,
    viewBox: "0 0 20.434 24.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_152",
    "data-name": "Tracciato 152",
    d: "M30.5,8.437A1.446,1.446,0,0,0,29.036,9.9v9.039a.548.548,0,0,1-.582.581.557.557,0,0,1-.592-.581V11.059a1.453,1.453,0,1,0-2.907,0v7.876a.557.557,0,0,1-.592.581.548.548,0,0,1-.582-.581V14.558a1.454,1.454,0,1,0-2.907,0v13.7a4.674,4.674,0,0,0,4.662,4.662H32.07a3.956,3.956,0,0,0,2.823-1.195l.031.032L40.7,25.87a2.018,2.018,0,1,0-2.855-2.855l-1.807,1.808V11.64a1.459,1.459,0,0,0-2.918,0v7.295a.582.582,0,0,1-1.163,0V9.9A1.446,1.446,0,0,0,30.5,8.437Zm-3.859,13.7L29,24.506l2.358-2.368L32.8,23.586l-2.358,2.357,2.379,2.379L31.373,29.76,29,27.392l-2.379,2.379-1.448-1.448,2.379-2.379-2.368-2.368Z",
    transform: "translate(-20.875 -8.437)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistCritical);
export default __webpack_public_path__ + "static/media/ChecklistCritical.4ca14e2cbce9dfa8d156f6d9589f768e.svg";
export { ForwardRef as ReactComponent };